// What a pick in the workspace menu, or a child's *Open Northwind*, does with
// the session (02-DESIGN/03-console/01-the-console.md § the shape: the
// workspace menu; hq decision 0069 points 5 and 6). A membership's row is a
// workspace the sign-in admits: the session names it before the page moves,
// so its address places the person with no page asking first. A child the
// sign-in is not a member of is its own sign-in page, and the session keeps
// the workspace that admitted the person; nothing is read across the
// relation. A placement the picked workspace refuses lands on its sign-in
// page too, with the refusal's sentence, and the session returns to the
// workspace the person came from.

/** Pick is a move to another workspace: home here, entering a membership, or its sign-in page. */
export type Pick =
  | { kind: "home" }
  | { kind: "enter"; slug: string; state: Entering }
  | { kind: "sign-in"; slug: string; state: Entering };

/** Entering is what a pick carries in the navigation state to the workspace it goes to. */
export interface Entering {
  /** The workspace the session named before a membership pick: where it returns on a refusal. */
  from?: string;
  /** Show the workspace's own sign-in page, though the session names another. */
  signIn?: boolean;
  /** The sentence of the refusal that sent a pick to the sign-in page. */
  refused?: string;
}

/**
 * planPick decides a pick: `member` says whether the sign-in is the
 * platform's and the picked workspace is among its memberships.
 */
export function planPick(here: string, to: string, member: boolean): Pick {
  if (to === here) {
    return { kind: "home" };
  }
  return member
    ? { kind: "enter", slug: to, state: { from: here } }
    : { kind: "sign-in", slug: to, state: { signIn: true } };
}

/** enteringOf reads a pick's navigation state, or nothing where it is none. */
export function enteringOf(state: unknown): Entering | undefined {
  if (typeof state !== "object" || state === null) {
    return undefined;
  }
  const r = state as Record<string, unknown>;
  const out: Entering = {};
  if (typeof r.from === "string" && r.from !== "") {
    out.from = r.from;
  }
  if (r.signIn === true) {
    out.signIn = true;
  }
  if (typeof r.refused === "string" && r.refused !== "") {
    out.refused = r.refused;
  }
  return Object.keys(out).length === 0 ? undefined : out;
}
